const KEYS = ["√","π","²","³","^","÷","×","±","∞","∑","∫","≠","≤","≥","°","(",")","π/2","π/3","π/4","1/2","1/3"];

export default function MathKeyboard({ onInsert }) {
  return (
    <div className="mt-4">
      <div className="font-mono text-[10px] tracking-[0.3em] text-zinc-500 mb-2">MATH KEYBOARD</div>
      <div className="grid grid-cols-8 sm:grid-cols-12 gap-1.5">
        {KEYS.map(k => (
          <button key={k} type="button" onClick={()=>onInsert(k)}
            className="aspect-square flex items-center justify-center bg-black/40 border border-white/10 hover:bg-cyan-500/20 hover:border-cyan-400/50 text-sm font-mono transition-colors"
            data-testid={`mathkey-${k}`}>{k}</button>
        ))}
      </div>
    </div>
  );
}
